import React, { useContext } from 'react';
import { SideNavigation, TopButton } from '../components';
import { SideNavContext } from '../contexts';
import Header from '../components/header/Header';
import NoticeDetail from '../components/support/NoticeDetail';
import Footer from '../components/footer/Footer';

const NoticeDetailPage = () => {

    const { isSideNavOpen } = useContext(SideNavContext);

    return (
        <>
            {isSideNavOpen && <SideNavigation />}

            <Header />

            <main>
                <NoticeDetail />
            </main>

            <Footer />

            <TopButton />
        </>
    );
};

export default NoticeDetailPage;